<template>
    <box-loading v-if="isLoading"></box-loading>
    <div v-else class="data-steps">
        <div class="data-steps__title">
            <h3>{{ $t('connect.step4TitlePage') }}</h3>
        </div>
        <div class="mb-3" v-if="!isEdit">
            <div class="form-group d-flex">
                <label class="d-block mb-2 mr-4 cursor-pointer" for="newShare">
                    <input class="radio_animated cursor-pointer" id="newShare" v-model="typeShare" :value="'form-filter'" type="radio" />
                    {{ $t('settingField.share') }}
                </label>
                <label class="d-block mb-2 cursor-pointer" for="newShareMulti">
                    <input class="radio_animated cursor-pointer" id="newShareMulti" v-model="typeShare" :value="'form-multi-filter'" type="radio" />
                    {{ $t('settingField.shareMulti') }}
                </label>
            </div>
        </div>

        <template v-if="typeShare === 'form-filter'">
            <form-filter
                :list-members="listMembers"
                :is-loading-list-member="isLoadingListMember"
                :data.sync="dataShare"
                :valueShare.sync="valueShare"
                :isEdit="isEdit"
                :errorShareName="errorShareName"
            >
            </form-filter>
        </template>
        <template v-else-if="typeShare === 'form-multi-filter'">
            <form-multi-filter :data.sync="dataShare" :user-fields="user_fields" :setting-multi-filter.sync="settingMultiFilter" :errorShareName="errorShareName"> </form-multi-filter>
        </template>
        <div class="card-footer footer-buttons">
            <Button @click="handlePrevStep" classes="btn-sm mr-3" type="warning">
                <i class="el-icon-back"></i>
                {{ $t('connect.prevStep') }}
            </Button>
            <Button :disabled="isLoading" v-if="!isEdit" @click="handleNextStep" classes="btn-sm" type="primary">
                {{ $t('button.save') }}
            </Button>
            <Button :disabled="isLoading" v-else @click="handleUpdateData" classes="btn-sm" type="primary">
                {{ $t('button.saveNew') }}
            </Button>
        </div>
    </div>
</template>

<script>
import Button from '@/components/partials/Button';
import { groupByData, validMaxLength, validRequired, isEmpty } from '@/utils';
import { USER_FIELDS } from '@/config/constants';
import BoxLoading from '@/components/partials/BoxLoading';
import formMultiFilter from './step4/multiFilter';
import formFilter from './step4/filter';
export default {
    name: 'step-filter',
    props: ['data'],
    components: {
        BoxLoading,
        Button,
        formMultiFilter,
        formFilter
    },
    data() {
        return {
            dataShare: this.data,
            isLoading: false,
            typeShare: this.data.typeShare,
            errorShareName: '',
            isLoadingListMember: false,
            listMembers: [],
            valueShare: {},
            user_fields: this.$ld.cloneDeep(USER_FIELDS),
            settingMultiFilter: []
        };
    },
    created() {
        this.getListAllMember();
        this.getListSettingField();
    },
    watch: {
        dataShare: {
            deep: true,
            handler: function () {
                this.$emit('update:data', this.dataShare);
            }
        }
    },
    computed: {
        isEdit() {
            return !!this.$route.query.id;
        }
    },
    methods: {
        getListSettingField() {
            let successCallback = (response) => {
                let data = response.data.data.setting;
                data.forEach((item) => {
                    this.user_fields.push({ value: item.field_id, label: item.field_name });
                });
            };
            let errorCallback = () => {};
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('settingField/detail', payload);
        },
        getListAllMember() {
            if (this.isLoadingListMember) return;
            this.isLoadingListMember = true;
            let successCallback = (response) => {
                if (response.status) {
                    let { data } = response.data;
                    let listMemberGet = data.data_list || [];
                    this.listMembers = [];
                    let listMemberByGroup = groupByData(listMemberGet, 'company_name');
                    this.listMembers = [];
                    if (listMemberByGroup) {
                        Object.keys(listMemberByGroup).map((key) => {
                            let item = {
                                company: key,
                                options: listMemberByGroup[key]
                            };
                            this.listMembers.push(item);
                        });
                    }
                }
                this.isLoadingListMember = false;
            };
            let errorCallback = () => {
                this.isLoadingListMember = false;
            };
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('member/getListAllChildren', payload);
        },
        handlePrevStep() {
            this.$emit('prevStep');
        },
        handleNextStep() {
            if (this.typeShare === 'form-filter') {
                this.nextFilter();
            } else if (this.typeShare === 'form-multi-filter') {
                this.nextMultiFilter();
            }
        },
        nextFilter() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    if (response.status === 200) {
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: this.$t('share.msgCreateSuccess')
                        });
                        this.$router.push({ name: 'shareList' });
                    }
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let dataPayload = {
                    link_name: this.dataShare.shareName,
                    workspace_id: this.dataShare.workspace_id,
                    app_id: this.dataShare.app_id,
                    app_name: this.dataShare.app_name,
                    view_id: this.dataShare.view_id,
                    view_name: this.dataShare.view_name,
                    data_filter: this.dataShare.dataFilter ? this.dataShare.dataFilter.replaceAll('filterCond=', '') : '',
                    array_filter: this.dataShare.arrayContentFilter || [],
                    array_field_view: this.dataShare.arrayFieldView || null,
                    array_field_disabled: this.dataShare.arrayFieldDisabled || null,
                    array_field_detail_hidden: this.dataShare.fieldDisplayLayout || null,
                    value_share: this.valueShare,
                    id_banner: this.dataShare.id_banner,
                    link_banner: this.dataShare.link_banner
                };
                let payload = {
                    successCallback,
                    errorCallback,
                    data: dataPayload
                };
                this.$store.dispatch('connect/createListConnect', payload);
            }
        },

        nextMultiFilter() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('share.msgCreateSuccess')
                    });
                    this.$router.push({ path: '/data-link-multi' });
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let dataPayload = {
                    link_name: this.dataShare.shareName,
                    workspace_id: this.dataShare.workspace_id,
                    app_id: this.dataShare.app_id,
                    app_name: this.dataShare.app_name,
                    view_id: this.dataShare.view_id,
                    view_name: this.dataShare.view_name,
                    data_filter: this.dataShare.dataFilter ? this.dataShare.dataFilter.replaceAll('filterCond=', '') : '',
                    array_filter: this.dataShare.arrayContentFilter || [],
                    array_field_view: this.dataShare.arrayFieldView || null,
                    array_field_disabled: this.dataShare.arrayFieldDisabled || null,
                    array_field_detail_hidden: this.dataShare.fieldDisplayLayout || null,
                    role_id: this.dataShare.rolesMultiFilter,
                    setting: this.settingMultiFilter,
                    id_banner: this.dataShare.id_banner,
                    link_banner: this.dataShare.link_banner,
                    condition_setting: this.dataShare.condition_setting
                };
                let payload = {
                    successCallback,
                    errorCallback,
                    data: dataPayload
                };
                this.$store.dispatch('dataLinkMulti/create', payload);
            }
        },
        handleUpdateData() {
            if (this.typeShare === 'form-filter') {
                this.updateFilter();
            } else if (this.typeShare === 'form-multi-filter') {
                this.updateMultiFilter();
            }
        },
        updateFilter() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('share.msgUpdateSuccess')
                    });
                    this.$router.push({ name: 'shareList' });
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let dataPayload = {
                    link_name: this.dataShare.shareName,
                    workspace_id: this.dataShare.workspace_id,
                    app_id: this.dataShare.app_id,
                    app_name: this.dataShare.app_name,
                    view_id: this.dataShare.view_id,
                    view_name: this.dataShare.view_name,
                    data_filter: this.dataShare.dataFilter ? this.dataShare.dataFilter.replaceAll('filterCond=', '') : '',
                    value_share: {},
                    array_filter: this.dataShare.arrayContentFilter || [],
                    array_field_view: this.dataShare.arrayFieldView || null,
                    array_field_disabled: this.dataShare.arrayFieldDisabled || null,
                    array_field_detail_hidden: this.dataShare.fieldDisplayLayout || null,
                    user_id_share: '',
                    role_share: {},
                    id_banner: this.dataShare.id_banner,
                    link_banner: this.dataShare.link_banner
                };
                this.dataShare.listMemberShare.map((elm, index) => {
                    if (index === 0) {
                        dataPayload.user_id_share = elm.member_id;
                        dataPayload.role_share = {
                            1: elm.roles.includes('detail'),
                            2: elm.roles.includes('create'),
                            3: elm.roles.includes('update'),
                            4: elm.roles.includes('delete'),
                            5: elm.roles.includes('export')
                        };
                    }
                });
                let payload = {
                    successCallback,
                    errorCallback,
                    data: dataPayload,
                    id: this.$route.query.id
                };
                this.$store.dispatch('connect/updateListConnect', payload);
            }
        },
        updateMultiFilter() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('share.msgUpdateSuccess')
                    });
                    this.$router.push({ path: '/data-link-multi' });
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let dataPayload = {
                    link_name: this.dataShare.shareName,
                    workspace_id: this.dataShare.workspace_id,
                    app_id: this.dataShare.app_id,
                    app_name: this.dataShare.app_name,
                    view_id: this.dataShare.view_id,
                    view_name: this.dataShare.view_name,
                    data_filter: this.dataShare.dataFilter ? this.dataShare.dataFilter.replaceAll('filterCond=', '') : '',
                    array_filter: this.dataShare.arrayContentFilter || [],
                    array_field_view: this.dataShare.arrayFieldView || null,
                    array_field_disabled: this.dataShare.arrayFieldDisabled || null,
                    array_field_detail_hidden: this.dataShare.fieldDisplayLayout || null,
                    role_id: this.dataShare.rolesMultiFilter,
                    setting: this.settingMultiFilter,
                    id_banner: this.dataShare.id_banner,
                    link_banner: this.dataShare.link_banner,
                    condition_setting: this.dataShare.condition_setting
                };
                let payload = {
                    successCallback,
                    errorCallback,
                    data: dataPayload,
                    id: this.$route.query.id
                };
                this.$store.dispatch('dataLinkMulti/update', payload);
            }
        },
        onValidate() {
            let check = true;
            if (!validRequired(this.dataShare.shareName)) {
                this.errorShareName = this.$t('share.msgShareNameRequired');
                check = false;
            } else if (!validMaxLength(this.dataShare.shareName, 255)) {
                this.errorShareName = this.$t('share.msgShareNameMaxLength');
                check = false;
            } else {
                this.errorShareName = '';
            }

            if (isEmpty(this.valueShare) && this.typeShare === 'form-filter' && !this.isEdit) {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'error',
                    message: this.$t('settingField.shareEmpty')
                });
                check = false;
            }

            if (this.settingMultiFilter.length === 0 && this.typeShare === 'form-multi-filter') {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'error',
                    message: this.$t('settingField.settingNull')
                });
                check = false;
            }
            return check;
        }
    }
};
</script>
